import { BiSolidCameraPlus, BiBuildings, BiLogoMicrosoft, BiSolidBaguette, BiSolidBuildings } from "react-icons/bi";
import {
    BsBoxFill, BsFillPersonPlusFill, BsCameraVideoFill,
    BsCameraFill, BsFillKeyFill, BsFillFileEarmarkZipFill, BsFillImageFill,
    BsQuestionCircleFill, BsBoxArrowRight, BsFillPostcardFill,
    BsClipboard2PlusFill, BsFillPeopleFill, BsFillRocketTakeoffFill,
    BsPersonCircle, BsClockFill, BsWebcam, BsKanbanFill
} from "react-icons/bs";
import {
    ProfileManagementIcon, CompanyManagementIcon, ProjectManagementIcon,
    BrandIcon, CameraSettingsIcon, ErrorEmailIcon,
    UserPermissionsIcon, TimeLapseCameraIcon, HomeIcon,
    LiveCameraIcon,
    AICameraIcon
} from '../components/icons/CustomIcons';
import { TbBrandWindowsFilled } from "react-icons/tb";
import { FaMicrosoft } from "react-icons/fa6";
import { ReactComponent as TaskMngementIcon } from "../assets/icons/Outline/24/Taskmngement.svg";

// import Profile from "../pages/auth/Profile"
import Login from "../pages/auth/Login"
import Dashboard from "../pages/dashboard/Dashboard";
import Role from "../pages/permissions/Role"
import Profile from "../pages/auth/Profile";
// import UserRole from "../pages/permissions/UserRole";
// import UserView from "../pages/users/View";
import PackageView from '../pages/packages/View';
import CamSettingsView from '../pages/cam_props/View';
import BrandView from '../pages/brands/View';

import CompanyView from '../pages/company/View';
import CompanyUserLimits from '../pages/company_limits/CompanyUserLimits';
import UserManagementView from '../pages/users/View';
import ProjectView from '../pages/project/View';
import ErrorMailView from '../pages/errschmail/ErrorMail';
import UserPermissionView from '../pages/userperm/View';
import MessagesView from '../pages/messages/View';

import Timelapse from "../pages/videos/Timelapse";
import ImageArchive from "../pages/archives/ImageArchive";
import VideoArchive from "../pages/archives/VideoArchive";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";

import AIAllCam from "../pages/aicamera/AIAllCam";
import TimeLineView from "../pages/tasks/View";
import ProgressView from "../pages/tasks/ProgressView";
import TaskView from "../pages/tasks/TaskView";
import SiteView from "../pages/tasks/SiteView";
import Cameras from "../pages/cameras/Cameras";
import AdminCameraView from "../pages/admin_cameras/View";
import Devices from "../pages/solar/Devices";
import IM from "../pages/cam_preview/IM";
import PtzStation from "../pages/cam_preview/PtzStation";
import {
    HelpIcon, PackageIcon, PermissionsIcon,
} from "../components/icons/CustomIcons";
import { Project24, Usermangement24, Videoarchives24 as VideoArchives24, Imagearchives24 as ImageArchives24, Timelapsecamera24 } from "../components/icons/Icons";


export const anonyMenus = [
    {
        to: "/",
        component: <Login />,
    },
    {
        to: "/login/",
        component: <Login />,
    },
    {
        to: "/forgot-password/",
        component: <ForgotPassword />,
    },
    {
        to: "/reset-password/",
        component: <ResetPassword />,
    },

]
const iconColor = "#5D6C7B"
export const menus = [

    {
        icon: <HomeIcon variant="filled" color={iconColor} />,
        label: "Dashboard",
        to: "/",
        proxyto: [
            { to: "/dashbord/", component: <Dashboard /> },
            { to: "/profile/", component: <Profile /> }, /*profile is not in menu so setup in proxyto*/
        ],
        component: <Dashboard />,
        permission: "*",
    },

    {
        icon: <CompanyManagementIcon variant="filled" color={iconColor} />,
        label: "IMage Viewer",
        to: "/camera-preview/",
        component: <IM />,
        permission: "view_camera",
        owner: ["User", "Campany"],
        changeText: "My Company",
        hide: true,
        hideSideBar: true,
        hideHeader: true,
        proxyto: [
            { to: "/change-view/", component: <Dashboard /> },
            { to: "/markup-tool/", component: <Profile /> }, /*profile is not in menu so setup in proxyto*/
        ],
    },
    {
        icon: <LiveCameraIcon variant="filled" color={iconColor} />,
        label: "PTZ Station",
        to: "/ptz-control/",
        component: <PtzStation />,
        permission: "view_camera",
        owner: ["User", "Campany"],
        hide: true,
        hideSideBar: true,
        hideHeader: true,
    },
    {
        icon: <CompanyManagementIcon variant="filled" color={iconColor} />,
        label: "Company",
        to: "/company/",
        component: <CompanyView />,
        permission: "view_company",
        owner: ["User", "Campany"],
        changeText: "My Company"
    },
    {
        icon: <Project24 variant="filled" viewBox="0 0 24 24" color={iconColor} />,
        label: "Project",
        to: "/project/",
        component: <ProjectView />,
        permission: "view_project",
    },

    {
        icon: <span className="menu-path-fill"><TaskMngementIcon size={24} variant="filled" fill={iconColor} /></span>,
        label: "Task",
        to: "/progress/",
        component: <TimeLineView />,
        permission: "view_workprogress",
        proxyto: [
            { to: "/sites/", component: <SiteView /> },
            { to: "/edit_progress/", component: <ProgressView /> },
            { to: "/tasks/", component: <TaskView /> }
        ],
    },

    {
        icon: <Usermangement24 size={24} viewBox="0 0 24 24" variant="filled" color={iconColor} />,
        label: "User",
        to: "/user-management/",
        component: <UserManagementView />,
        permission: "view_user",
    },
    {
        icon: <LiveCameraIcon size={24} variant="filled" color={iconColor} />,
        label: "Cameras",
        to: "/cameras/",
        component: <Cameras />,
        permission: "view_camera",
        proxyto: [
            { to: "/control-center/", component: <Devices /> }
        ],
    },

    // {
    //     icon: <BsCameraFill size={20} />,
    //     label: "Camera",
    //     to: "/camera/",
    //     component: <Dashboard />,
    //     permission: "*",
    //     submenus: [
    //         {
    //             icon: <BsCameraFill size={19} />,
    //             label: "Timelapse <br/> Camera",
    //             to: "/timelapse-all/",
    //             component: <TimelapseAllCam />,
    //             permission: "can_view_timelapse",
    //         },
    //         {
    //             icon: <BsCameraVideoFill size={19} />,
    //             label: "Network <br/> Camera",
    //             to: "/network-all/",
    //             component: <LiveAllCam />,
    //             permission: "can_view_livecam",
    //         },
    //         {
    //             icon: <BsWebcam />,
    //             label: "AI Camera",
    //             to: "/aicamera/",
    //             component: <AIAllCam />,
    //             permission: "can_view_aicamera",
    //         },
    //     ]
    // },
    // {
    //     icon: <TimeLapseCameraIcon size={24} variant="filled" color={iconColor} />,
    //     label: "Timelapse <br/> Camera",
    //     to: "/timelapse-all/",
    //     component: <TimelapseAllCam />,
    //     permission: "can_view_timelapse",
    // },
    // {
    //     icon: <LiveCameraIcon size={24} variant="filled" color={iconColor} />,
    //     label: "Network <br/> Camera",
    //     to: "/network-all/",
    //     component: <LiveAllCam />,
    //     permission: "can_view_livecam",
    // },
    // {
    //     icon: <AICameraIcon size={24} variant="filled" color={iconColor} />,
    //     label: "AI Camera",
    //     to: "/aicamera/",
    //     component: <AIAllCam />,
    //     permission: "can_view_aicamera",
    // },

    {
        icon: <BsClockFill size={19} color={iconColor} />,
        label: "Timelapse <br/>Video",
        to: "/camera-management/",
        component: <Timelapse />,
        permission: "view_camera",
        proxyto: [
            { to: "/timelapse/", component: <Timelapse /> }
        ]
    },


    {
        icon: <ImageArchives24 size={24} variant="filled" viewBox="0 0 24 24" color={iconColor} />,
        label: "Image <br/>Archives",
        to: "/image-archive/",
        component: < ImageArchive />,
        permission: "view_camera",
    },
    {
        icon: <VideoArchives24 size={24} variant="filled" viewBox="0 0 24 24" color={iconColor} />,
        label: "Video <br/>Archives",
        to: "/video-archive/",
        component: <VideoArchive />,
        permission: "view_camera",
    },

    {
        icon: <PermissionsIcon size={24} variant="filled" color={iconColor} />,
        label: "More...",
        to: "/role/",
        component: <Role />,
        permission: "view_permission",
        submenus: [
            {
                icon: <PermissionsIcon size={24} variant="filled" color={iconColor} />,
                label: "Permissions",
                to: "/role/",
                component: <Role />,
                permission: "view_permission",
            },
            {
                icon: <UserPermissionsIcon size={24} variant="filled" color={iconColor} />,
                label: "User <br/>Permission",
                to: "/user-permission/",
                component: <UserPermissionView />,
                permission: "view_permission",

            },
            {
                icon: <BsFillPeopleFill size={20} color={iconColor} />,
                label: "Company User <br/> Limits",
                to: "/company-user-limits/",
                component: <CompanyUserLimits />,
                permission: "view_company",
                adminOnly: true,
            },
            {
                icon: <ErrorEmailIcon size={24} variant="filled" color={iconColor} />,
                label: "Schedule <br/>Error Mail",
                to: "/error-schedule/",
                component: <ErrorMailView />,
                permission: "view_permission",

            },
            {
                icon: <PackageIcon size={24} variant="filled" color={iconColor} />,
                label: "Package",
                to: "/packages/",
                component: <PackageView />,
                permission: "view_package",
            },
            {
                icon: <BrandIcon size={24} variant="filled" color={iconColor} />,
                label: "Brand",
                to: "/brands/",
                component: <BrandView />,
                permission: "view_permission",
            },

            {
                icon: <CameraSettingsIcon size={24} variant="filled" color={iconColor} />,
                label: "Camera <br/> Settings",
                to: "/live-camera-settings/",
                component: <CamSettingsView />,
                permission: "view_permission",
            },
            {
                icon: <BsCameraVideoFill size={20} color={iconColor} />,
                label: "Camera <br/> Registry",
                to: "/admin-cameras/",
                component: <AdminCameraView />,
                permission: "view_camera",
                adminOnly: true,
            },
        ]
    },






    {
        icon: <BiLogoMicrosoft size={24} color={iconColor} />,
        label: "Envelop Message",
        to: "/messages/",
        component: <MessagesView />,
        permission: "*",
        hide: true,
    },

    {
        icon: <HelpIcon size={24} variant="filled" color={iconColor} />,
        label: "Helps",
        to: "/help/",
        component: <></>,
        permission: "*",
    },
]